import { Input, Space } from 'antd'
import { ResizableBox } from 'react-resizable'
import Feather from '@sysunite/react-feather'
const { TextArea } = Input

export class LogContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      logs: [],
      pollerFn: () => undefined
    };
  }

  componentWillUnmount() {
    clearInterval(this.state.pollerFn)
  }

  componentDidMount() {
    this.setState({
      pollerFn: setInterval(async () => await this.setLogs(), 1000)
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.logs.length !== this.state.logs.length) {
      const log = document.querySelector('.logs')
      log.scrollTop = log.scrollHeight
    }
  }

  async setLogs() {
    const { orchestrator, uid } = this.props
    const l = await orchestrator.logs({ jobUid: uid, level: "silly" })
    const parsedLogs = JSON.parse(l)
    const allLevels = parsedLogs.map(({ message }) => { return message })
    this.setState({ logs: allLevels })
  }

  render() {
    const { logs } = this.state

    return (
      <Space
        direction='vertical'
        style={{ width: '100%' }}
      >
        <ResizableBox
          height={400}
          width={Infinity}
          minConstraints={[80, 80]}
          axis="y"
          handle={
            <div className="resize-handler">
              <Feather
                strokeWidth={2}
                size='2em'
                type="chevron-down"
              />
            </div>
          }
        >
          <TextArea
            className="logs"
            value={logs.join('\n')}
          />
        </ResizableBox>
      </Space>
    )
  }
}

export default LogContent
